import React, { Component } from 'react';
// import { Row, Col } from 'react-bootstrap';
import { Loader } from 'src/components';
import { withRouter } from 'react-router-dom';
import { ACTION_TYPES } from 'src/constants';
import moment from 'moment';
import EventBus from 'eventing-bus';
import { Container } from '../../components';
import CancelRequestsTable from './cancel-requests-table';
import styles from './_cancel-requests.module.scss';

class CancelRequests extends Component {
  state = {
    loading: false,
    pageNumber: 1,
    filteredData: [],
    searchAmount: '',
    totalCount: 0,
    searchDate: '',
  };

  _handlePaginationChange = (pageNumber) => {
    this.setState(
      {
        pageNumber,
      },
      () =>
        this.props.requestAdminCancelRequestList({
          page: pageNumber,
        }),
    );
  };

  componentDidMount() {
    this.requestAdminCancelRequestList = EventBus.on(
      ACTION_TYPES.CANCEL_REQUESTS_LIST_REQUEST,
      () => this.setState({ loading: true }),
    );
    this.requestAdminCancelRequestListSuccess = EventBus.on(
      ACTION_TYPES.CANCEL_REQUESTS_LIST_SUCCESS,
      () => {
        const { savingGoals, savingGoalsTotal } = this.props.cancelRequests;
        this.setState({ loading: false });
        this.setState({ filteredData: savingGoals || [], totalCount: savingGoalsTotal });
      },
    );
    this.requestAdminCancelRequestListFailure = EventBus.on(
      ACTION_TYPES.CANCEL_REQUESTS_LIST_FAILED,
      () => this.setState({ loading: false }),
    );

    this.props.requestAdminCancelRequestList({
      page: this.state.pageNumber,
    });
  }

  componentWillUnmount() {
    this.requestAdminCancelRequestList();
    this.requestAdminCancelRequestListSuccess();
    this.requestAdminCancelRequestListFailure();
  }

  handleChange = (e) => {
    const { savingGoals } = this.props.cancelRequests;
    const { searchAmount, searchDate } = this.state;
    let filteredData = savingGoals || [];

    if (e.target.name === 'searchAmount' || (searchAmount && e.target.name !== 'searchAmount')) {
      let regex = new RegExp(
        searchAmount && e.target.name !== 'searchAmount' ? searchAmount : e.target.value,
        'i',
      );
      filteredData = filteredData.filter((item) => regex.test(item?.amount));
    }

    if (e.target.name === 'searchDate' || (searchDate && e.target.name !== 'searchDate')) {
      const dateValue = searchDate && e.target.name !== 'searchDate' ? searchDate : e.target.value;
      if (dateValue) {
        filteredData = filteredData.filter(
          (item) => moment(item?.createdAt, 'DDMMYYYY').format('YYYY-MM-DD') === dateValue,
        );
      }
    }

    this.setState({
      [e.target.name]: e.target.value,
      filteredData,
      totalCount: filteredData.length || 0,
    });
  };

  render() {
    const { loading, filteredData, totalCount } = this.state;

    return (
      <div className={styles['payment-links']}>
        <Container title="Cancel Requests">
          <CancelRequestsTable
            data={filteredData}
            totalItems={totalCount}
            handlePaginationChange={this._handlePaginationChange}
          />
        </Container>
        <Loader loading={loading} />
      </div>
    );
  }
}

export default withRouter(CancelRequests);
